export const tableSx = {
  borderBottom: '2px solid #fff',
  '&:nth-of-type(even)': {
    bgcolor: '#fff',
  },
  '&:nth-of-type(odd)': {
    bgcolor: 'rgba(234,234,236,.3)',
  },
  '&:nth-of-type(even):hover': {
    bgcolor: '#fff',
  },
  '&:nth-of-type(odd):hover': {
    bgcolor: 'rgba(234,234,236,.3)',
  },
};
